export const ONBOARDING_BLOCK = {
  TITLE: 'Finish onboarding',
  STEPS: 'Steps',
  OF: 'of',
}

export const ONBOARDING_MODAL = {
  TITLE: "You're almost there!",
  DESCRIPTION: 'Congratulations on completing onboarding!',
  DETAIL:
    'We will confirm your account very soon and you will be ready to receive your first bookings.',
  BUTTON: 'Got it',
}

export const REGISTRATION_SUCCESS_MODAL = {
  TITLE: 'Finish your onboarding',
  DESCRIPTION:
    'Fill in the missing information on the following pages to finish your onboarding:',
  MENU_ITEMS_LIST:
    '<li>Profile</li><li>Documents</li><li>Locations</li><li>Cars</li><li>Price lists</li><li>Terms & Conditions</li>',
  BUTTON: 'Finish onboarding',
}
